<template>
  <editor
    :api-key="tinyMceApiKey"
    class="input textarea"
    v-model="content"
    :inline="showToolbarInline"
    :init="{
      fixed_toolbar_container: '#' + toolbarContainer,
      menubar: false,
      statusbar: false,
      directionality : direction,
      plugins: tinyMcePlugins,
      toolbar: currentToolBar
     }"/>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import { tinyMceToolbar, tinyMceToolbarLtr, tinyMceFullToolbar, tinyMceFullToolbarLtr, tinyMcePlugins, tinyMceApiKey } from '@/constants.js'
import { mapState } from 'vuex'
export default {
  name: 'tiny-editor',

  data () {
    return {
      tinyMceToolbar, tinyMceToolbarLtr, tinyMcePlugins, tinyMceApiKey
    }
  },

  props: {
    toolbarContainer: {
      type: String,
      default: 'toolbar-container'
    },
    text: {
      type: String,
      default: ''
    },
    fullToolbar: {
      type: Boolean,
      default: false
    },
    showToolbarInline: {
      type: Boolean,
      default: true
    }
  },

  components: {
    Editor
  },

  computed: {
    ...mapState({
      direction: state => state.base.directionSystem
    }),
    content: {
      get () {
        return this.text
      },
      set (value) {
        this.$emit('update:text', value)
      }
    },
    currentToolBar () {
      if (this.fullToolbar) {
        if (this.direction === 'ltr') {
          return tinyMceFullToolbarLtr
        } else {
          return tinyMceFullToolbar
        }
      } else {
        if (this.direction === 'ltr') {
          return tinyMceToolbarLtr
        }
        return tinyMceToolbar
      }
    }
  }
}
</script>

<style scoped>

</style>
